import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  decimalScale?: number;
}

const CustomNumericInput = React.forwardRef<NumericFormatProps, CustomProps>(
  function CustomNumericInput(props, ref) {
    const { onChange, name, decimalScale, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        decimalScale={decimalScale === undefined ? 2 : decimalScale}
        fixedDecimalScale
        valueIsNumericString
      />
    );
  },
);

export default CustomNumericInput;
